/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Json_Output_LabelInputs */

const en_json_output_label = /** @type {(inputs: Json_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Output`)
};

const ko_json_output_label = /** @type {(inputs: Json_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 출력`)
};

const ja_json_output_label = /** @type {(inputs: Json_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON出力`)
};

/**
* | output |
* | --- |
* | "JSON Output" |
*
* @param {Json_Output_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const json_output_label = /** @type {((inputs?: Json_Output_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Json_Output_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_json_output_label(inputs)
	if (locale === "ko") return ko_json_output_label(inputs)
	return ja_json_output_label(inputs)
});